export default __webpack_public_path__ + "static/media/CreateBill.41052b4c.svg";